// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8 ? "b8e21824" : chunkId) + "." + {"8":"60d188ff6dbeea18","46":"435fa8040a89e901","393":"c2d973ba05a81726","808":"a92885f1d40a7576"}[chunkId] + ".js";
};